// Static landing copy taken from the PSD. Channel-configurable bits (caption,
// images, color, logo) come from settings via useLandingSettings.

export const FEATURE_CARDS = [
  { icon: 'network', text: '1.3 million providers in Cigna’s nationwide network' },
  { icon: 'savings', text: 'Save up to 50% compared to Marketplace plans' },
  { icon: 'clock', text: 'Ultra-fast quotes ready in under 5 minutes' },
] as const;

export const PLUS_BENEFITS = [
  "A private health plan that uses Cigna's national PPO network",
  'Instant quoting (in most cases)',
  'Fast, easy enrollment featuring our AI assistant, Alia',
  'Premiums starting at $570 per month (a 20-50% savings compared to Marketplace PPO plans)',
  '8 deductible options, including 2 HSA-compatible plan options',
  'A streamlined member portal that makes it easy to manage your plan',
  'No hidden limits on care or coverage',
];

export const QUALIFY_INTRO =
  'OneHealth Plus is a private program built for individuals and families who:';

export const QUALIFY_ITEMS = [
  'Are in good health',
  "Make over $70K per year and don't qualify for ACA tax credits*",
  'Are under the age of 65',
  'Value PPO coverage',
];

export const QUALIFY_FOOTNOTE =
  "*Premiums start at $570 per month for an individual plan, which reflects a 20-50% savings over ACA plans with a similar level of coverage (Gold plans and above) for those who don't qualify for income-based tax credits.";

export const PLAN_HIGHLIGHTS = [
  'A care network that includes 1.3 million providers across 50 states',
  'The ability to see any doctor in or out of network',
  'The flexibility to see a specialist without a referral',
  'The option to choose a primary care provider or not',
  '$0 copay telemedicine',
];

export const CIGNA_DIRECTORY_URL =
  'https://hcpdirectory.cigna.com/web/public/consumer/directory/search';

export const EASY_STEPS = [
  'Complete a health questionnaire',
  'Instantly see your plan options and rates',
  'Pick the plan that’s right for you and enroll',
];

export interface Testimonial {
  stars: number;
  quote: string;
  author: string;
}

export const TESTIMONIALS: Testimonial[] = [
  {
    stars: 5,
    quote:
      'Great experience with One Health Plus. It was significantly better than what I had through the exchange, and they made the process smooth, straightforward, and stress-free from start to finish.',
    author: 'Salman R.',
  },
  {
    stars: 5,
    quote:
      'I saved so much money! The enrollment was super easy and I found good doctors in my area. The coverage is great.',
    author: 'Bridgette H.',
  },
  {
    stars: 5,
    quote:
      'Easier than marketplace and cheaper too. So far we have had an easy, smooth experience. Glad we found this option.',
    author: 'Trudy K.',
  },
];

export const FOOTER_HEADLINE = [
  'Coverage that’s clear.',
  'Support that feels personal.',
  'All in one place.',
];

export const FOOTER_DISCLAIMER =
  'The information provided on this website is for general informational purposes only and does not constitute insurance advice, a contract, or a guarantee of coverage. Insurance products, coverage options, and eligibility may vary by provider, state, and individual circumstances. Plan availability and benefits are subject to change without notice. We strive to ensure the accuracy of the information presented; however, we do not warrant or guarantee its completeness or reliability. For specific details regarding coverage, exclusions, costs, and limitations, please refer to your policy documents or consult with a licensed insurance professional. By using this website, you acknowledge and agree that the company is not responsible for any decisions made based on the information provided herein. For personalized insurance recommendations, please contact a licensed agent.';
